<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">
          {{ $t(pageTitle) }}
        </h1>
        <div class="table-input inner">
          <div class="content">
            <table class="table table-bordered">
              <tbody class="tbody">
                <tr>
                  <th class="table-active text-left">{{ $t('取込設定名') }} <span class="text-danger">&nbsp;{{ $t("※必須") }}</span></th>
                  <td class="text-left">
                    <input v-model="form.name" type="text" class="form-control input">
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">{{ $t('区切り文字') }}<span class="text-danger">&nbsp;{{ $t("※必須") }}</span></th>
                  <td class="text-left">
                    <div class="form-check form-check-inline">
                      <input
                      class="form-check-input"
                      v-model="form.delimiter"
                      type="radio" id="comma"
                      value="comma"
                      checked="checked">
                      <label class="form-check-label" for="comma">
                      {{ $t("カンマ") }}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                      class="form-check-input"
                      v-model="form.delimiter"
                      type="radio" id="tab" value="tab">
                      <label class="form-check-label" for="tab">
                      {{ $t("TAB") }}
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">{{ $t('ヘッダあり') }}</th>
                  <td class="text-left">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="form.isHeader" />
                        {{ $t('ヘッダあり') }}
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">{{ $t('サンプルデータ読込') }}</th>
                  <td class="text-left">
                    <div class="input-group">
                      <div class="custom-file d-flex justify-content-center">
                        <input @change="onFileChange" type="file" class="custom-file-input" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04">
                        <label class="custom-file-label d-flex align-items-center" for="inputGroupFile04" data-browse="参照">{{ selectFile ? selectFile.name : $t('ファイルを選択(ここにドロップすることもできます)') }}</label>
                      </div>
                      <div class="input-group-append">
                        <button @click="loadFile" class="btn btn-outline-secondary" type="button" id="inputGroupFileAddon04">読込</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-5 table-input inner">
          <div class="content">
            <table class="table table-bordered">
              <thead class="thead">
                <tr>
                  <th class="table-active">{{ $t('固定値の設定') }}</th>
                  <th class="table-active">{{ $t('取込項目') }}</th>
                  <th class="table-active">{{ $t('固定値の入力') }}</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-for="(item, index) in form.fixedValues" :key = index>
                  <td class="text-left">
                  </td>
                  <td class="text-left">
                    <select v-model="item.key" class="form-control input-sm">
                      <option value selected></option>
                      <option v-for="(importItem,index) in importItems" :key="`fixedValues-${index}`" :value="importItem.key">{{ $t(importItem.value) }}</option>
                    </select>
                  </td>
                  <td class="text-left">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        v-model="item.type"
                        type="radio"
                        :id="`fixedValues-${index}-blank`"
                        value="today">
                      <label class="form-check-label" :for="`fixedValues-${index}-blank`">
                      {{ $t("本日日付") }}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :id="`fixedValues-${index}-fix`"
                        v-model="item.type"
                        value="fix">
                      <label class="form-check-label" :for="`fixedValues-${index}-fix`">
                      {{ $t("固定値") }}
                      </label>
                      <span class="ml-2">
                        <input v-model="item.value" type="text" class="form-control input ml-2 ">
                      </span>
                    </div>
                    <span>
                      <button
                        type="button"
                        class="btn-danger btn float-right mr-5"
                        @click="deleteSettingForm(index)"
                      >{{ $t("削除") }}</button>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="inner d-flex justify-content-start mt-4 mb-4">
          <button type="button" @click="addSettingForm()" class="btn btn-light">{{ $t('追加') }}</button>
        </div>
        <div class="mt-5 table-input inner">
          <div class="content">
            <h2 class="fz-20 d-flex border-bottom mt-0">{{ $t('取込設定') }}</h2>
            <div class="content">
            <table class="table table-bordered">
              <thead class="thead">
                <tr>
                  <th class="table-active">{{ $t('ヘッダ') }}</th>
                  <th class="table-active">{{ $t('サンプルデータ') }}</th>
                  <th class="table-active">{{ $t('取込項目') }}</th>
                  <th class="table-active">{{ $t('文字列抽出') }}</th>
                  <th class="table-active">{{ $t('変換1') }}</th>
                  <th class="table-active">{{ $t('変換2') }}</th>
                  <th class="table-active">{{ $t('空の時に入れる値') }}</th>
                  <th class="table-active">{{ $t('変換結果') }}</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-for="(item, key) in form.importValues" :key="key">
                  <td class="text-left">
                    <input v-model="item.header" type="text" class="form-control input" readonly>
                  </td>
                  <td class="text-left">
                    <input v-model="item.sample" type="text" class="form-control input" readonly>
                  </td>
                  <td class="text-left">
                    <select @change="updateConversionResult(item)" v-model="item.key" class="form-control input-sm">
                      <option value selected></option>
                      <option v-for="(importItem,index) in importItems" :key="`importValues-${index}`" :value="importItem.key">{{ $t(importItem.value) }}</option>
                    </select>
                  </td>
                  <td class="text-left">
                    <input @change="updateConversionResult(item)" v-model.number="item.subStringStart" size="4" type="text" class="form-control input input-sub-string">
                    {{ $t('文字目～') }}
                    <input @change="updateConversionResult(item)" v-model.number="item.subStringEnd" size="4" type="text" class="form-control input input-sub-string">
                    {{ $t('文字目まで') }}
                  </td>
                  <td>
                    <select @change="updateConversionResult(item)" v-model="item.stringConvert1" class="form-control" name="cnv-form-0-convert_type_1">
                      <option value></option>
                      <option value="toHalf">全角⇒半角</option>
                      <option value="toFull">半角⇒全角</option>
                      <option value="toLower">大文字⇒小文字</option>
                      <option value="toUpper">小文字⇒大文字</option>
                    </select>
                  </td>
                  <td>
                    <select @change="updateConversionResult(item)" v-model="item.stringConvert2" class="form-control" name="cnv-form-0-convert_type_1">
                      <option value></option>
                      <option value="toHalf">全角⇒半角</option>
                      <option value="toFull">半角⇒全角</option>
                      <option value="toLower">大文字⇒小文字</option>
                      <option value="toUpper">小文字⇒大文字</option>
                    </select>
                  </td>
                  <td class="text-left">
                    <div class="form-check">
                      <input
                      @change="updateConversionResult(item)"
                      v-model="item.blankType"
                      class="form-check-input"
                      type="radio" :id="`importValues-${key}-blank`" value="blank">
                      <label class="form-check-label" :for="`importValues-${key}-blank`">
                      {{ $t("空") }}
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                      @change="updateConversionResult(item)"
                      v-model="item.blankType"
                      class="form-check-input"
                      type="radio" :id="`importValues-${key}-today`" value="today">
                      <label class="form-check-label" :for="`importValues-${key}-today`">
                      {{ $t("本日日付") }}
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                      @change="updateConversionResult(item)"
                      v-model="item.blankType"
                      class="form-check-input"
                      type="radio" :id="`importValues-${key}-fix`" value="fix">
                      <label class="form-check-label" :for="`importValues-${key}-fix`">
                      {{ $t("固定値") }}
                      </label>
                      <span>
                        <input @change="updateConversionResult(item)" v-model.lazy="item.blankValue" type="text" class="form-control input ml-2 ">
                      </span>
                    </div>
                  </td>
                  <td class="text-left">
                    <p>{{ item.conversionResult }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
        </div>
        <p class="inner text-danger text-left" v-if="error">{{ error }}</p>
        <div class="inner d-flex justify-content-start mt-4 mb-4">
          <button type="button" class="btn btn-success mr-3 d-flex align-items-center justify-content-center wf-60" :disabled="registering" @click="register()">
              <div class="d-flex justify-content-center align-items-center mr-3" v-if="registering">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </div>
              {{ $t("登録") }}
          </button>
          <button type="button" class="btn btn-light"  :disabled="registering" @click="returnPage()">{{ $t("キャンセル") }}</button>
        </div>
      </div>
  </common-template>
</template>

<script>
import moment from 'moment/moment'
import { mapGetters } from 'vuex'
import importItems from '../../assets/json/inventory-import.json'
const form = {
  type: 'inventory',
  name: '',
  delimiter: 'comma',
  isHeader: false,
  fixedValues: [],
  importValues: [],
}
const importValueSize = 14
export default {
  data() {
    return {
      form: {},
      error: '',
      registering: false,
      status: 'new',
      collapseActive: true,
      importItems: importItems,
      selectFile: null,
      pageTitle: '設定編集',
    }
  },
  async created() {
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(err)
      this.$toasted.show('Userの取得でエラー')
    }
    try {
      // パラメータがあれば、Formにデータを入れる
      const url = location.search
      const searchParams = new URLSearchParams(url)
      if (searchParams.get('id')) {
        // idがあればapiから情報を取得
        let params = {
          type: 'inventory',
        }
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/import/settings`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
          params: params,
        })
        this.form = res.data.filter(value=> value.id == Number(searchParams.get('id')))[0]
      } else {
        this.form = this.mixin_deepcopy(form)
        // fixedValuesをデフォルト3つになるまで並べる
        while (this.form.fixedValues.length < 3) {
          this.form.fixedValues.push({})
        }
      }
      // importValuesをimportValueSizeになるまで並べる
      while (this.form.importValues.length < importValueSize) {
        this.form.importValues.push({
          'stringConvert1': 'none',
          'stringConvert2': 'none',
          'subStringStart': '',
          'subStringEnd': '',
          'blankType': 'blank',
          'blankValue': '',
        })
      }
    } catch (err) {
      this.$toasted.show(err)
    }
    const url = location.search
    const searchParams = new URLSearchParams(url)
    if (searchParams.get('code')) {
      this.form.code = String(searchParams.get('code'))
    }
    this.form.importValues.map(item => this.updateConversionResult(item))
  },
  mounted() {
    $('#drawing').on('show.bs.collapse', function() {
      const up = document.getElementById('drawing-up')
      const down = document.getElementById('drawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#drawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('drawing-up')
      const down = document.getElementById('drawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
    $('#drawing').collapse('show')
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    // 製品の一覧か詳細に戻る処理
    returnPage() {
      window.history.back()
    },
    // 登録処理
    async register() {
      if (!this.form.name) return this.error = this.$t('取込設定名') + this.$t('必須メッセージ')
      if (!this.form.delimiter) return this.error = this.$t('区切り文字') + this.$t('必須メッセージ')
      if (!this.validateImportItems()) return this.error = this.$t('取込項目「品番」は必須です')
      this.error = ''
      this.registering = true
      let params = {}
      for (let key of Object.keys(this.form)) {
        if (this.form[key] != null && this.form[key] != undefined && this.form[key] !== '') params[key] = this.form[key]
      }

      // 空のform情報を消す
      params.fixedValues = params.fixedValues.filter(value => value.key || value.type)
      // params.importValues = params.importValues.filter(value => value.key && (value.sample || value.header ||  value.key || value.stringConvert1 || value.stringConvert2 || value.blankType))

      // 変換結果を消す
      params.importValues.forEach(value => {
        if (!value.subStringStart) {
          delete value.subStringStart
        }
        if (!value.subStringEnd) {
          delete value.subStringEnd
        }
        delete value.conversionResult
        if (!value.key) value.key = ''
      })

      try {
        let method = 'post'
        if (params.id) method = 'put'
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/import/setting`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        window.location.href = process.env.NODE_ENV !== 'development' ? '/base/inventory-import/index.html' : '/inventory-import/index.html'
      } catch (error) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.registering = false
    },
    // フォーム追加
    addSettingForm() {
      const additionalForm = {}
      this.form.fixedValues.push(additionalForm)
    },
    // フォーム削除
    deleteSettingForm(id) {
      this.form.fixedValues.splice(id, 1)
    },
    validateImportItems() {
      const itemValues = this.form.importValues.concat(this.form.fixedValues)
      const firstFilter = itemValues.filter(value => value.key == 'productCode')
      // const secondFilter = itemValues.filter(value => value.key == 'productVersion')
      // const thirdFilter = itemValues.filter(value => value.key == 'baseQuantity')
      // const fourthFilter = itemValues.filter(value => value.key == 'supplyLotSize')
      // const fifthFilter = itemValues.filter(value => value.key == 'supplyLeadTime')
      return firstFilter.length
    },
    validateFixedValues() {
      const fixedValues = this.form.fixedValues.filter(value => value.key || value.type)

      if (!fixedValues.length) {
        return true
      }

      for (const index in fixedValues) {
        const value = fixedValues[index]
        if (!value.key || !value.type) {
          return false
        }
      }
      return true
    },
    validateImportValues() {
      const importValues = this.form.importValues.filter(value =>
        value.key && (value.header || value.sample || value.stringConvert1 || value.stringConvert2 || value.blankType))

      if (!importValues.length) {
        return true
      }

      for (const index in importValues) {
        const value = importValues[index]
        if (!value.key || !value.stringConvert1 || !value.stringConvert2 || !value.blankType) {
          return false
        }
      }
      return true
    },
    isNullOrEmpty(val) {
      return (val == null || val === '')
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      this.selectFile = files[0]
    },
    loadFile() {
      this.$toasted.clear()
      if (!this.selectFile) return

      let file = this.selectFile

      if (!/\.[ct]sv$/i.test(file.name)) {
        this.$toasted.show(this.$t('ファイルの形式が異なります'))
        return
      }

      for (const index in this.form.importValues) {
        const importValue = this.form.importValues[index]
        delete importValue.sample
        delete importValue.header
      }

      this.mixinReadImportCSV(file, data => {
        if (this.form.isHeader) {
          for (let i in data[0]) {
            if (!this.form.importValues[i]) {
              this.form.importValues.push({})
            }
            this.$set(this.form.importValues[i], 'header', data[0][i])
          }
        }
        const leadNum = this.form.isHeader ? 1 : 0
        for (let i in data[leadNum]) {
          if (!this.form.importValues[i]) this.form.importValues.push({})
          this.$set(this.form.importValues[i], 'sample', data[leadNum][i])
          this.$set(this.form.importValues[i], 'conversionResult', '')
          this.updateConversionResult(this.form.importValues[i])
        }

        this.form.importValues = this.form.importValues.filter(value => value.sample || value.header)
      })
    },
    updateConversionResult(item) {
      if (!item.sample) {
        // 空の場合の処理
        switch (item.blankType) {
          case 'blank': {
            item.conversionResult = ''
            break
          }
          case 'today': {
            item.conversionResult = (new moment()).format('YYYY-MM-DD')
            break
          }
          case 'fix': {
            item.conversionResult = item.blankValue
            break
          }
        }
        return
      } else {
        item.conversionResult = item.sample
      }
      let subStringStart = 0
      if (item.subStringStart) {
        subStringStart = item.subStringStart - 1
      }
      // 文字列抽出
      item.conversionResult = item.conversionResult.substr(subStringStart, Number(item.subStringEnd) ? Number(item.subStringEnd) : item.conversionResult.length - subStringStart)

      // 変換1
      this.stringConversion(item, item.stringConvert1)
      // 変換2
      this.stringConversion(item, item.stringConvert2)

    },
    stringConversion(item, stringConvert) {
      // 文字列変換
      switch (stringConvert) {
        case 'toHalf': {
          item.conversionResult = item.conversionResult.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(input) {
            return String.fromCharCode(input.charCodeAt(0) - 0xFEE0)
          })
          break
        }
        case 'toFull': {
          item.conversionResult =
          item.conversionResult.replace(/[A-Za-z0-9]/g, function(input) {
            return String.fromCharCode(input.charCodeAt(0) + 0xFEE0)
          })
          break
        }
        case 'toLower': {
          item.conversionResult = item.conversionResult.toLowerCase()
          break
        }
        case 'toUpper': {
          item.conversionResult = item.conversionResult.toUpperCase()
          break
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .accordion {
    cursor: pointer;
  }
  .custom-file-label {
    height: 3.8rem;
      &::after {
        height: 3.6rem;
        display: flex;
        align-items: center;
      }
  }
  .form-control[readonly] {
    background-color: #fff;
  }
</style>
